const FIRST_PARTY_ROOT_DOMAIN = "resimoprobleme.com";

export function getFirstPartyCookieDomain(
  hostname: string,
): string | undefined {
  const normalizedHostname = hostname.toLowerCase().replace(/\.$/, "");

  if (
    normalizedHostname === FIRST_PARTY_ROOT_DOMAIN ||
    normalizedHostname.endsWith(`.${FIRST_PARTY_ROOT_DOMAIN}`)
  ) {
    return `.${FIRST_PARTY_ROOT_DOMAIN}`;
  }

  return undefined;
}
